import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AuthForm from './AuthForm';

const PublicLanding = () => {
    const [isLoggingIn, setIsLoggingIn] = React.useState(false);
    const { demoModeEnabled, login } = useAuth();

    const handleLogin = (provider) => {
        if (isLoggingIn) return;
        setIsLoggingIn(true);
        login(provider);
    };

    return (
        <main className="flex justify-center items-center py-12 px-4">
            <div className="bg-bg-panel p-8 md:p-12 rounded-lg border border-border-light shadow-2xl w-full max-w-xl">
                <div className="mb-8">
                    <AuthForm />
                </div>

                <div className="relative my-8">
                    <div className="absolute inset-0 flex items-center">
                        <div className="w-full border-t border-border-light"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                        <span className="px-2 bg-bg-panel text-text-muted">Or continue with</span>
                    </div>
                </div>

                <div className="flex flex-col gap-4">
                    <button
                        onClick={() => handleLogin('google')}
                        disabled={isLoggingIn}
                        className="flex items-center justify-center gap-3 px-4 py-3 border border-border-light rounded font-semibold text-white transition-colors duration-200 bg-transparent hover:bg-white/5 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" className="w-5 h-5" />
                        {isLoggingIn ? 'Redirecting...' : 'Login with Google'}
                    </button>

                    {demoModeEnabled && (
                        <button
                            onClick={() => handleLogin('demo')}
                            disabled={isLoggingIn}
                            className="px-4 py-3 border-none rounded font-semibold cursor-pointer transition-colors duration-200 bg-gray-700 text-white hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {isLoggingIn ? 'Logging in...' : 'Demo Login (Local Testing)'}
                        </button>
                    )}
                </div>
                
                <div className="mt-12 space-y-4 text-center">
                    <p className="text-xs text-text-muted leading-relaxed">
                        {demoModeEnabled && ' Demo Login is available for local testing.'}
                    </p>
                    <p className="text-xs text-accent-red font-medium opacity-80">
                        This game is in Early Access. The Database will be wiped periodically.
                    </p>
                </div>
            </div>
        </main>
    );
};

export default PublicLanding;
